// components/admin/AdminLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Drawer, AppBar, Toolbar, Typography } from "@mui/material";
import { useAdminStyles } from "./styles";
import { AdminSidebar } from "./AdminSidebar";
import { THEME_COLORS } from "../../context/constants";

export const AdminLayout: React.FC = () => {
  const classes = useAdminStyles();

  return (
    <Box className={classes.adminLayout}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 250,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 250,
            boxSizing: "border-box",
            backgroundColor: THEME_COLORS.darkYellow,
            color: "white",
          },
        }}
      >
        <AdminSidebar />
      </Drawer>

      {/* Main Content */}
      <Box className={classes.adminContent}>
        {/* Header */}
        <AppBar
          position="static"
          sx={{ backgroundColor: THEME_COLORS.darkYellow }}
        >
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Admin Panel
            </Typography>
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box className={classes.adminMain}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
